import { fetchChannelInstanceById as requestFn } from '../clients/fetchChannelInstanceById';
import { FETCH_CHANNEL_INSTANCE_BY_ID as actionTypes } from '../constants/asyncActionTypes';
import ChannelInstance from '../../public/records/ChannelInstance';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
export const fetchChannelInstanceById = createAsyncAction({
  requestFn,
  actionTypes,
  toRecordFn: response => ChannelInstance(response)
});